import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { AppErrorBoundary } from "./components/common/RouteErrorPage";
import { router } from "./routes";
import NewVersionBanner from "./components/common/NewVersionBanner";
import { useBuildVersionWatcher } from "./hooks/useBuildVersionWatcher";

function App() {
  const { updateAvailable, reload } = useBuildVersionWatcher();



  return (
    <ThemeProvider>
      <AuthProvider>
        <AppErrorBoundary>
          <RouterProvider router={router} />
        </AppErrorBoundary>
      </AuthProvider>
      <NewVersionBanner visible={updateAvailable} onRefresh={reload} />
    </ThemeProvider>
  );
}

export default App;
